var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46323 6.74895C1.1285 7.08368 0.585786 7.08368 0.251051 6.74895C-0.0836838 6.41421 -0.0836838 5.8715 0.251051 5.53677L5.39391 0.39391C5.7184 0.0694141 6.2409 0.0580606 6.57919 0.368155L11.722 5.08244C12.071 5.40232 12.0946 5.94452 11.7747 6.29348C11.4548 6.64244 10.9126 6.66601 10.5637 6.34613L6.02578 2.1864L1.46323 6.74895Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.20ed4457002feef912f05277d38e8e8b.svg";
export { ForwardRef as ReactComponent };